import React from 'react';
import './Tabs.css';

export const Tabs = ({ children, activeTab, onTabChange, className = '' }) => {
  return (
    <div className={`custom-tabs ${className}`}>
      <div className="tabs-header">
        {React.Children.map(children, (child) => (
          <button
            key={child.props.id}
            className={`tab-button ${activeTab === child.props.id ? 'active' : ''}`}
            onClick={() => onTabChange(child.props.id)}
            role="tab"
            aria-selected={activeTab === child.props.id}
            aria-controls={`panel-${child.props.id}`}
            tabIndex={activeTab === child.props.id ? 0 : -1}
          >
            <span className="tab-text">{child.props.title}</span>
            {activeTab === child.props.id && <span className="tab-active-indicator" />}
          </button>
        ))}
      </div>
      <div className="tabs-content">
        {React.Children.map(children, (child) => (
          <div 
            key={child.props.id}
            className={`tab-pane ${activeTab === child.props.id ? 'active' : ''}`}
            role="tabpanel"
            id={`panel-${child.props.id}`}
            aria-labelledby={child.props.id}
            hidden={activeTab !== child.props.id}
          >
            {child}
          </div>
        ))}
      </div>
    </div>
  );
};

export const Tab = ({ children, id, title }) => {
  return (
    <div className="tab-content-inner">
      {children}
    </div>
  );
}; 